// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EscalatorService } from './escalator-service';


export class EscalatorServiceMessage implements flatbuffers.IUnpackableObject<EscalatorServiceMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EscalatorServiceMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEscalatorServiceMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorServiceMessage):EscalatorServiceMessage {
  return (obj || new EscalatorServiceMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEscalatorServiceMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorServiceMessage):EscalatorServiceMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EscalatorServiceMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():EscalatorService {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : EscalatorService.Auto;
}

static startEscalatorServiceMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:EscalatorService) {
  builder.addFieldInt16(0, message, EscalatorService.Auto);
}

static endEscalatorServiceMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createEscalatorServiceMessage(builder:flatbuffers.Builder, message:EscalatorService):flatbuffers.Offset {
  EscalatorServiceMessage.startEscalatorServiceMessage(builder);
  EscalatorServiceMessage.addMessage(builder, message);
  return EscalatorServiceMessage.endEscalatorServiceMessage(builder);
}

unpack(): EscalatorServiceMessageT {
  return new EscalatorServiceMessageT(
    this.message()
  );
}


unpackTo(_o: EscalatorServiceMessageT): void {
  _o.message = this.message();
}
}

export class EscalatorServiceMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: EscalatorService = EscalatorService.Auto
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return EscalatorServiceMessage.createEscalatorServiceMessage(builder,
    this.message
  );
}
}
